import {
  addContactIntegrationsProperties,
  DEFAULT_GRAPHQL_OBJECT_DEPTH_FOR_SYNC_QUERY,
  getContact,
  removeNestedFieldsExcept,
  syncContacts,
} from '@rentguru/commons-utils';

const GET_QUERY_OBJECT_DEPTH = 1;

const CONTACT_RELATIONS_TO_REMOVE = [
  'address',
  'buildings',
  'foreignEntityRelations',
  'leases',
  'sourceEntityRelations',
  'units',
];

const CONTACT_NESTED_FIELDS_TO_KEEP = [
  'acpSyndicEras',
  'acpSyndicHistory',
  'customValues',
  'emails',
  'hoaFunds',
  'integrations',
  'jointOwners',
  'peppolProperties',
  'phoneNumbers',
  'supplierPaymentModeExceptions',
  'supplierPaymentModeHistory',
];

const CONTACT_FIELDS_LOADED_ON_DEMAND = ['supplierPaymentModeHistory'];

const reduceContactQuery = (query: string, objectDepth: number, fieldsToRemove: string[]): string =>
  addContactIntegrationsProperties(
    removeNestedFieldsExcept(
      query,
      objectDepth,
      CONTACT_RELATIONS_TO_REMOVE,
      CONTACT_NESTED_FIELDS_TO_KEEP,
      fieldsToRemove
    )
  );

export const CONTACTS_QUERY = reduceContactQuery(
  syncContacts,
  DEFAULT_GRAPHQL_OBJECT_DEPTH_FOR_SYNC_QUERY,
  CONTACT_FIELDS_LOADED_ON_DEMAND
);

export const CONTACT_QUERY = reduceContactQuery(getContact, GET_QUERY_OBJECT_DEPTH, CONTACT_FIELDS_LOADED_ON_DEMAND);

export const CONTACT_WITH_PAYMENT_MODE_HISTORY_QUERY = reduceContactQuery(getContact, GET_QUERY_OBJECT_DEPTH, []);
